import React from 'react';
import classNames from 'classnames';
import { Term } from '@benzinga/content-manager';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import styles from './PostedIn.module.scss';

export interface PostedInProps {
  terms: Term[];
  variant?: 'default' | 'secondary';
}

export const PostedIn = ({ terms, variant = 'default' }: PostedInProps) => {
  if (!Array.isArray(terms) || (Array.isArray(terms) && !terms.length)) return null;
  return (
    <div
      className={classNames(
        styles.container,
        'article-taxonomy',
        variant === 'default' ? styles.containerDefault : styles.containerSecondary,
      )}
    >
      {variant === 'default' && <strong className="mr-2">Posted In: </strong>}
      <div className="posted-in-list">
        {terms.map((term: Term) => {
          if (!term) return null;
          return (
            <a
              className={classNames(styles.link, variant === 'default' ? styles.linkDefault : styles.linkSecondary)}
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(term.name) }}
              href={term.url_public ? `/${term.url_public}` : `/taxonomy/term/${term.tid}`}
              key={term.tid}
            />
          );
        })}
      </div>
    </div>
  );
};
